import {Navigate} from 'react-router-dom'
import {CompanyPage} from 'app/pages/Company/CompanyPage'
import {isMarketplaceHostname} from 'app/utils/homePath'

/**
 * `/unidade/:slug` só faz sentido no marketplace.
 * Em subdomínios de branch, redireciona para `/`.
 */
const UnidadeRoute = () => {
  if (!isMarketplaceHostname()) {
    return <Navigate to='/' replace />
  }
  return <CompanyPage />
}

export {UnidadeRoute}
